import { html } from "htm/preact";

import type * as Bible from "../modules/bible";

import { useBibleSettings } from "./BibleContent";

export const BibleContentChapter = ({
  chapter,
}: {
  chapter: Bible.ContentChapter;
}) => {
  const settings = useBibleSettings();
  if (!settings.showChapters) return null;
  return html`<h1 class="BibleContentChapter" part="bible-content-chapter">
    ${chapter.book.name} ${chapter.number}
  </h1>`;
};
